import React from 'react';
import styles from './style.module.scss';
import Row from './row';
import SkeletonRow from "../../../../components/skeleton-loader/table/row";

const Table = ({
  loading,
  data,
  fetchData
}) => {
  return (
    <table className={styles.table} >
      <thead className={styles.tableHead} >
        <tr className={styles.theadRow} >
          <th className={`${styles.th} ${styles.w40px}`} >
          </th>
          <th className={`${styles.th} ${styles.w140px}`} >
            <div className={styles.flex} >
              <span>ID</span>
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`} >
            <div className={styles.flex} >
              <span>Kurv Office</span>
            </div>
          </th>
          <th className={`${styles.th}`} >
            <div className={styles.flex} >
              <span>Name</span>
            </div>
          </th>
          <th className={`${styles.th}`} >
            <div className={styles.flex} >
              <span>Risk Type</span>
            </div>
          </th>
          <th className={`${styles.th} ${styles.w40px}`} ></th>
        </tr>
      </thead>

      <tbody className={styles.tableBody} >
        {loading ? (
          Array.from({ length: 8 }).map((_, index) => (
            <SkeletonRow key={`skeleton-${index}`} columnLength={6} />
          ))
        ) : (
          (data || []).map((item, index) => (
            <Row key={index} data={item} fetchData={fetchData} />
          ))
        )}
      </tbody>
    </table>
  )
}

export default Table